import { useEffect } from 'react';

interface UseAutoScrollOptions {
  enabled: boolean;
  advance: () => void;
  interval: number;
}

export default function useAutoScroll({ enabled, advance, interval }: UseAutoScrollOptions) {
  useEffect(() => {
    if (!enabled) return;
    if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

    const id = setInterval(advance, interval);

    return () => clearInterval(id);
  }, [enabled, advance, interval]);
}
